import DimensionResolver from '@/composables/charts/influx-charts/dimension-resolvers/DimensionResolver.js'
import { useAdmiralStore } from '@/store/admiralStore.js'
import { useInstanceStore } from '@/store/backendInstances.js'

class VMSInstanceGUIDResolver extends DimensionResolver {
  async prepareResolver() {
    if (this.prepared) return
    this.reloadedOnce = false
    await super.prepareResolver()
    const admiralStore = useAdmiralStore()
    const allInstances = await admiralStore.queryVMSInstances({ projection: { only: ['globalUniqueIdentifier', 'name'] } })
    this.instanceMap = new Map()
    if (allInstances) {
      allInstances.forEach(instance => {
        this.instanceMap.set(instance.globalUniqueIdentifier, instance.name)
      })
    }
  }
  async doesTagKeyMatch(tag) {
    return tag === 'vmsUniqueId'
  }

  async humanizeTagValue(tagValue) {
    return this.instanceMap.get(tagValue) || tagValue
  }
  static isRelevantForCurrentInstance() {
    return useInstanceStore().selectedInstance.instanceType === 'admiral'
  }
}
export default VMSInstanceGUIDResolver
